import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';
import moment from 'moment'

const toast = useToast();
const useBivalentVaccineStore = defineStore({
    id: 'bivalentVaccine',
    state: () => ({
        form: {
            optionList: [
                {
                    id: 'selfPayingVaccine',
                    displayName: 'bivalentVaccine.selfPayingVaccine'
                }
            ],
            ageList: [
                {
                    id: 'age1217',
                    displayName: 'bivalentVaccine.age1217'
                },
                {
                    id: 'age1849',
                    displayName: 'bivalentVaccine.age1849'
                },
                {
                    id: 'age50+',
                    displayName: 'bivalentVaccine.age50+'
                },
            ],
            covidRecoveryDateList: [
                {
                    id: 'neverAffected',
                    displayName: 'bivalentVaccine.neverAffected'
                },
                {
                    id: 'within3m',
                    displayName: 'bivalentVaccine.within3m'
                },
                {
                    id: '3-6m',
                    displayName: 'bivalentVaccine.3-6m'
                },
                {
                    id: '6m+',
                    displayName: 'bivalentVaccine.6m+'
                },
            ],
            noOfPeopleList: [
                {
                    id: '6',
                    displayName: 'bivalentVaccine.people',
                },
                {
                    id: '7',
                    displayName: 'bivalentVaccine.people',
                },
                {
                    id: '8',
                    displayName: 'bivalentVaccine.people',
                },
                {
                    id: '9',
                    displayName: 'bivalentVaccine.people',
                },
                {
                    id: '10',
                    displayName: 'bivalentVaccine.people',
                },
                {
                    id: '10+',
                    displayName: 'bivalentVaccine.people',
                },
            ],
        },
        remarkList: [
            'bivalentVaccine.remark1',
            'bivalentVaccine.remark2',
            'bivalentVaccine.remark3'
        ],
        termsAndAgreementsList: [
            'bivalentVaccine.termsAndAgreements1',
            'bivalentVaccine.termsAndAgreements2',
            'bivalentVaccine.termsAndAgreements3',
            'bivalentVaccine.termsAndAgreements4'
        ],
    }),
    getters: {},
    actions: {
        async bookAppointment(body: object) {
            try {
                console.log('api: book appointment: ' + JSON.stringify(body));
                const response: any = await apiClient.post('/api/scwebsite/bookAppointment/', body);
                const isSuccess = response.statusCode;
                //debugger;
                if (!isSuccess) {
                    console.log('response? ' + JSON.stringify(response));
                    var error = Object.prototype.toString.call(response.errorMessage) === '[object Object]' ? JSON.stringify(response.errorMessage) : response.errorMessage;
                    throw new Error(error)
                }
                toast.success('Send Email Success');
                return isSuccess;
            } catch (err: any) {
                toast.error(err.message);
            }
        },
        availableTimeslot(appointmentTimeslot: number, startTime: string, endTime: string, startLunchTime: string, endLunchTime: string, haveLunchTime: boolean) {
            var availableTimeList = [];
            var startTimeStr = moment(startTime, "HH:mm").format("HH:mm");
            var endTimeStr = moment(endTime, "HH:mm").format("HH:mm");
            var startLunchTimeStr = moment(startLunchTime, "HH:mm").format("HH:mm");
            var endLunchTimStr = moment(endLunchTime, "HH:mm").format("HH:mm");
            var currentTime = startTimeStr
            availableTimeList[0] = startTimeStr;

            while (currentTime != endTimeStr) {
                currentTime = moment(currentTime, "HH:mm").add(appointmentTimeslot, "minutes").format("HH:mm");
                let lunchTime = moment(currentTime, "HH:mm").isBetween(moment(startLunchTimeStr, "HH:mm"), moment(endLunchTimStr, "HH:mm"))
                    || currentTime == endTimeStr
                    || currentTime == startLunchTimeStr
                if (lunchTime && haveLunchTime) continue;
                availableTimeList.push(currentTime);
            }
            return availableTimeList;
        },
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useBivalentVaccineStore, import.meta.hot));
}

export { useBivalentVaccineStore };
